var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid for-light",attrs:{"src":require("../../assets/images/logo/blast.jpg"),"alt":""}}),_c('img',{staticClass:"img-fluid for-dark",attrs:{"src":require("../../assets/images/logo/blast.jpg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }